import { Stack } from "@mui/material";
import { usePiggyUser } from "../../../utils/piggy/piggy.tsx";
import Slide from "@mui/material/Slide";
import "./shine.css";
import { LoyaltyCard } from "./LoyaltyCard/LoyaltyCard.tsx";
import PiggyVouchers from "../Vouchers/PiggyVouchers.tsx";
import PiggyRewards from "./PiggyRewards.tsx";
import React from "react";

export default function PiggyLoyaltyContent() {
  const { piggyUser } = usePiggyUser();

  return (
    <Slide in={Boolean(piggyUser)} direction="down" mountOnEnter unmountOnExit>
      <Stack sx={{ width: 1, my: 4 }} alignItems={"center"} direction={"column"} gap={6}>
        <LoyaltyCard wrapperSx={{ width: 600 }} />

        <PiggyRewards showBalance={false} wrapperSx={{ width: 1 }} />

        <PiggyVouchers wrapperSx={{ width: 1 }} />
      </Stack>
    </Slide>
  );
}
